export default {
  assets: {
    allAssets: {
      defaultMessage: 'All Assets',
      description: 'dashboard | assets row | all assets card title',
    },
    myVehicles: {
      defaultMessage: 'My Vehicles',
      description: 'dashboard | assets row | my vehicles card title',
    },
    myPtus: {
      defaultMessage: 'My PTUs',
      description: 'dashboard | assets row | my ptus card title',
    },
    vehiclesSharedWithMe: {
      defaultMessage: 'Vehicles Shared With Me',
      description: 'dashboard | assets row | vehicles shared with me card title',
    },
    ptusSharedWithMe: {
      defaultMessage: 'PTUs Shared With Me',
      description: 'dashboard | assets row | ptus shared with me card title',
    },
  },
  smartShares: {
    allShares: {
      defaultMessage: 'All Smart Shares',
      description: 'dashboard | smart shares row | all smart shares card title',
    },
    sharingVehiclesAndPTUs: {
      defaultMessage: 'Vehicles and PTUs I Am Sharing',
      description: 'dashboard | smart shares row | assets I am sharing card title',
    },
    sharedWithMe: {
      defaultMessage: 'Vehicles and PTUs Shared With Me',
      description: 'dashboard | smart shares row | assets shared with me card title',
    },
    sharingOnwards: {
      defaultMessage: 'Vehicles and PTUs Onward Shared',
      description: 'dashboard | smart shares row | assets I am sharing onwards card title',
    },
  },
  contacts: {
    allContacts: {
      defaultMessage: 'All Contacts',
      description: 'dashboard | contacts row | all contacts card title',
    },
    contactsShare: {
      defaultMessage: 'Contacts I Share Assets With',
      description: 'dashboard | contacts row | contacts I share assets with card title',
    },
    contactsSharing: {
      defaultMessage: 'Contacts Sharing With Me',
      description: 'dashboard | contacts row | contacts sharing with me card title',
    },
  },
  pageTitle: {
    defaultMessage: 'Dashboard',
    description: 'dashboard | page title',
  },
  addNew: {
    defaultMessage: 'Add New',
    description: 'dashboard | add new button label',
  },
}
